import React from "react";
import { StarFilled, StarOutlined } from "@/icons";
import { RatingCard, RatingLabel, StarsPill } from "./Rating.elements";

const Rating = (props) => {
    const v = Number(props.rating) || 0;
    const filled = Math.max(0, Math.min(5, Math.round(v)));

    return (
        <RatingCard>
            <RatingLabel title={props.title || "Rating"}>{props.title || "Rating"}</RatingLabel>

            <StarsPill>
                {[1, 2, 3, 4, 5].map((i) =>
                    i <= filled ? <StarFilled key={i} /> : <StarOutlined key={i} />
                )}
            </StarsPill>
        </RatingCard>
    );
};

export default Rating;
